import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import verifyIcon from '@/assets/benefit_verify.svg';
import conpensateIcon from '@/assets/benefit_compensate.svg';
import safeIcon from '@/assets/benefit_safe.svg';
import confirmIcon from '@/assets/benefit_confirm.svg';
import React from 'react';

const benefitItems = [
  {
    id: 'verify',
    icon: verifyIcon
  },
  {
    id: 'compensate',
    icon: conpensateIcon
  },
  {
    id: 'safe',
    icon: safeIcon
  },
  {
    id: 'confirm',
    icon: confirmIcon
  },
];

const BenefitItem = ({ icon, title }) => (
  <div className="w-full flex justify-center items-center gap-1.5">
    <img src={icon} alt={title} className="w-5 h-5 object-contain" />
    <div className="text-[#111111] text-sm font-normal leading-[21px]">{title}</div>
  </div>
);

const Benefits = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 w-full flex">
      {benefitItems.map((item, index) => (
        <React.Fragment key={item.id}>
          <BenefitItem
            key={item.id}
            icon={item.icon}
            title={t(`benefits.${item.id}.title`)}
          />
          {index < benefitItems.length - 1 && (
            <div className="w-px self-stretch bg-[#eeeeee] mx-1" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Benefits; 